import React from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import DefaultErrorBoundry from './DefaultErrorBoundry';
import LayoutContainer from './layout/LayoutContainer';
import {LayersProvider} from '../hooks/useLayersContext';
import {StoreProvider} from '../hooks/useStore';

function App() {
  return (
    <DefaultErrorBoundry>
      <Router>
        <StoreProvider>
          <LayersProvider>
            <LayoutContainer />
          </LayersProvider>
        </StoreProvider>
      </Router>
    </DefaultErrorBoundry>
  );
}

export default App;
